<section class="bk-panel sb-panel" aria-labelledby="seg-info-title">
  <h2 class="bk-section-title sb-panel__title" id="seg-info-title">Name and description</h2>
  <p class="sb-panel__lead">You will choose which contacts belong in the next step.</p>

  <form class="sb-fields" [formGroup]="segmentInformationForm" (ngSubmit)="goToRulesPage()" novalidate>
    <input-field label="Name" [errorMessage]="nameError">
      <input class="input-style" formControlName="segmentName" maxlength="120" />
    </input-field>

    <input-field label="Description" [errorMessage]="descriptionError" hint="Who it is for and when to use it.">
      <textarea class="input-style" formControlName="description" rows="3"></textarea>
    </input-field>

    <div class="sb-bar">
      <div class="sb-bar__group">
        <button type="button" class="bk-btn bk-btn--ghost" (click)="cancel()">Cancel</button>
      </div>
      <div class="sb-bar__group">
        @if (!isEditView) {
          <button type="button" class="bk-btn bk-btn--ghost" (click)="handleOpenSelectExistingRule()">
            <span class="bk-sym" aria-hidden="true">content_copy</span>
            Start from an existing segment
          </button>
        }
        <button type="submit" class="bk-btn bk-btn--primary">
          Next: conditions
          <span class="bk-sym sf-next" aria-hidden="true">arrow_forward</span>
        </button>
      </div>
    </div>
  </form>
</section>

<!-- Pick a segment to copy its conditions -->
@if (openSelectExistingRuleModal) {
  <select-existing-rule-modal [opeModal]="true" (closeModal)="handleCloseSelectExistingRule()" />
}
